import axios from 'axios'
import { GetUserAuthToken } from './config'
import { checkUserLogin, logoutAndClearCache } from './utils'
import { envConfig } from './envConfig'
import { AnalyticService } from '../lib/analytics/analyticService'

// to prevent overwriting the global axios config
const myAxios = axios.create()

const getUserToken = () => {
  if (typeof localStorage !== 'undefined') {
    return GetUserAuthToken()
    // || GetAdminUserToken();
  }

  return ''
}

const axiosConfig = {
  headers: {
    'x-access-request-source': 'demilade',
    'x-access-username': envConfig.NEXT_PUBLIC_API_USERNAME,
    'x-access-secret': envConfig.NEXT_PUBLIC_API_SECRET,
    // "x-access-token": getUserToken(),
    // this forces a re-calculation whenever a request is made
  },
}

myAxios.interceptors.request.use(req => {
  req.headers = axiosConfig.headers
  req.headers['x-access-token'] = getUserToken()
  return req
})

myAxios.interceptors.response.use(
  res => res,
  err => {
    // if (err.response.status === 404) {
    //   throw new Error(`${err.config.url} not found`);
    // }
    console.log('Error in request', err ? err.message : err)
    if (err && err.response && err.response.status === 401) {
      AnalyticService.onUserAutomatedLogout('401 response from server')

      logoutAndClearCache()
      checkUserLogin()
    }
    throw err
  },
)

export default myAxios
